// @dynamic-i18n-keys
// Dynamic t() at line 44: date.month.${month} (month 1–12):
//   date.month.1
//   date.month.2
//   date.month.3
//   date.month.4
//   date.month.5
//   date.month.6
//   date.month.7
//   date.month.8
//   date.month.9
//   date.month.10
//   date.month.11
//   date.month.12
import React from 'react';
import classnames from 'classnames';
import range from 'lodash/range';
import { useTranslation } from 'react-i18next';
import InputLayout from '../../InputLayout';
import NumbersDropdown from '../NumbersDropdown';

import s from './DateDropdowns.scss';

export interface Props {
  monthValue?: number;
  dayValue?: number;
  yearValue?: number;
  label?: string;
  className?: string;
  textUnderClassName?: string;
  dropdownFieldClassName?: string;
  onSelect?(field, value): void;
  namePrefix?: string;
  errorMessage?: string;
  /** @deprecated If true, will use the NativeDropdown (select) for input */
  forceNativeDropdown?: boolean;
}

const DateDropdowns: React.FC<React.PropsWithChildren<Props>> = props => {
  const { t } = useTranslation();
  const {
    namePrefix,
    monthValue,
    dayValue,
    yearValue,
    className,
    textUnderClassName,
    dropdownFieldClassName,
    label,
    onSelect,
    errorMessage,
    forceNativeDropdown = true,
  } = props;

  const days = range(1, 32).map(day => ({ value: day, label: day }));
  const months = range(1, 13).map(month => ({
    value: month,
    label: t(`date.month.${month}`),
  }));
  // UTC so new years eve doesn't cause SSR errors
  const currentYear = new Date().getUTCFullYear();
  // In case a current-day Jeanne Clement wants to use the site
  const years = range(currentYear, currentYear - 123, -1).map(year => ({
    value: year,
    label: year,
  }));

  return (
    <div className={className}>
      <InputLayout
        label={label}
        className={classnames(s['month'], dropdownFieldClassName)}
        textUnderClassName={textUnderClassName}
        isFilled
        isFocused={false}
        hasError={!!errorMessage}
        errorMessage={errorMessage}
      >
        <input type="hidden" name={`${namePrefix}Month`} value={monthValue} />
        <NumbersDropdown
          aria-label={t('datedropdown.month')}
          placeholder="Month"
          items={months}
          selectedValue={monthValue || ''}
          onSelect={value => onSelect && onSelect('month', value)}
          forceNativeDropdown={forceNativeDropdown}
        />
      </InputLayout>
      <InputLayout
        className={dropdownFieldClassName}
        isFilled
        isFocused={false}
      >
        <input type="hidden" name={`${namePrefix}Day`} value={dayValue} />
        <NumbersDropdown
          aria-label={t('datedropdown.day')}
          placeholder="Day"
          items={days}
          selectedValue={dayValue}
          onSelect={value => onSelect && onSelect('day', value)}
          forceNativeDropdown={forceNativeDropdown}
        />
      </InputLayout>
      <InputLayout
        className={dropdownFieldClassName}
        isFilled
        isFocused={false}
      >
        <input type="hidden" name={`${namePrefix}Year`} value={yearValue} />
        <NumbersDropdown
          aria-label={t('datedropdown.year')}
          placeholder="Year"
          items={years}
          selectedValue={yearValue}
          onSelect={value => onSelect && onSelect('year', value)}
          forceNativeDropdown={forceNativeDropdown}
        />
      </InputLayout>
    </div>
  );
};
DateDropdowns.displayName = 'DateDropdowns';

export default DateDropdowns;
